<div class="right-panel">
    @if (isVisitingCard()) {
        <div class="side-switcher">
            <span class="side-label">Visiting Card Side</span>
            <div class="side-buttons">
                <button
                    type="button"
                    class="side-button"
                    [class.active]="activeSide() === 'front'"
                    (click)="setActiveSide('front')">
                    Front
                </button>
                <button
                    type="button"
                    class="side-button"
                    [class.active]="activeSide() === 'back'"
                    (click)="setActiveSide('back')">
                    Back
                </button>
            </div>
        </div>
    }
    <div class="tabs-header">
        <button
            class="tab"
            [class.active]="activeTab() === 'properties'"
            (click)="activeTab.set('properties')">
            Properties
        </button>
        <button
            class="tab"
            [class.active]="activeTab() === 'layers'"
            (click)="activeTab.set('layers')">
            Layers
        </button>
        <button
            class="tab"
            [class.active]="activeTab() === 'gallery'"
            (click)="activeTab.set('gallery')">
            Gallery
        </button>
    </div>
    <div class="tab-content">
        @if (activeTab() === 'properties') {
            <app-properties-panel></app-properties-panel>
        } @else if (activeTab() === 'layers') {
            <app-layers-panel></app-layers-panel>
        } @else if (activeTab() === 'gallery') {
            <app-gallery-panel></app-gallery-panel>
        }
    </div>
</div>
